<template>
	<dl class="pointItemKbnInfo sort-item"
		v-if="!(ptInitData.siteKbn == '4' && !ptInitData.loginKbn && ptInitData.priceShowBtoB == 0) && ptInitData.priceShow != 1">
		<dt v-if="ptInitData.productInfo.POINT_ITEM_KBN == '1' || ptInitData.productInfo.POINT_ITEM_KBN == '2'">
			{{ $t('common.labels.exchangePoint') }}</dt>
		<template v-if="ptInitData.productInfo.POINT_ITEM_KBN == '1' || ptInitData.productInfo.POINT_ITEM_KBN == '2'">
			<dd>
				<span class="price">{{ formatPrice(ptInitData.productInfo.POINT_ITEM_NUM) }}{{ $t('common.labels.pt')
					}}</span>
			</dd>
		</template>
	</dl>
</template>
<script>
import common from "assets/js/common"; 
export default {
	name: 'pointItemKbnInfo',
	props: {
		ptInitData: {
			type: Object,
			default: null
		}
	},
	methods: {

		/**
	 * format number value to currency value
	 * @param {number} value, number to format
	 */
		formatPrice: function (value) {
			return common.formatPrice(value);
		},
	}
}
</script>